module.exports = __webpack_public_path__ + "static/loda-web-debf773aea9ceb7ed5ac333996f85ee3.jpg";